(function () {
  const guide = document.querySelector("[data-size-guide]");
  const fit = document.querySelector("[data-fit-assistant]");
  const contents = document.querySelectorAll(".yt-size-guide-content");
  if ((!guide && !fit && !contents.length) || document.documentElement.dataset.ytSizeBound === "true") return;
  document.documentElement.dataset.ytSizeBound = "true";

  const chart = {
    "2XS": "Bust 78.5 cm, waist 59.5 cm.",
    XS: "Bust 81–83.5 cm, waist 62–64.5 cm.",
    S: "Bust 86–91 cm, waist 65–72 cm.",
    M: "Bust 96–101 cm, waist 77–82 cm.",
    L: "Bust 106–113 cm, waist 87–94 cm.",
    XL: "Compare the size guide for the closest fit.",
  };

  let lastFocus = null;

  function lockPage() {
    document.documentElement.classList.add("yt-size-guide-open");
    if (window.lenis && typeof window.lenis.stop === "function") window.lenis.stop();
  }

  function unlockPage() {
    if ((guide && !guide.hidden) || (fit && !fit.hidden)) return;
    document.documentElement.classList.remove("yt-size-guide-open");
    if (window.lenis && typeof window.lenis.start === "function") window.lenis.start();
  }

  function openGuide(trigger) {
    if (!guide) return;
    lastFocus = trigger || document.activeElement;
    guide.hidden = false;
    requestAnimationFrame(() => guide.classList.add("is-open"));
    lockPage();
    const closeButton = guide.querySelector(".yt-size-guide__close");
    if (closeButton) closeButton.focus();
  }

  function closeGuide() {
    if (!guide) return;
    guide.classList.remove("is-open");
    guide.hidden = true;
    unlockPage();
    if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
  }

  function setUnits(unit, root) {
    if (!root) return;
    root.querySelectorAll("[data-unit]").forEach((button) => {
      button.setAttribute("aria-pressed", button.dataset.unit === unit ? "true" : "false");
    });
    root.querySelectorAll("[data-cm]").forEach((cell) => {
      cell.textContent = unit === "in" ? cell.dataset.in || "" : cell.dataset.cm || "";
    });
  }

  function openFit(trigger) {
    if (!fit) return;
    lastFocus = trigger || document.activeElement;
    fit.hidden = false;
    lockPage();
    const closeButton = fit.querySelector(".yt-fit__close");
    if (closeButton) closeButton.focus();
  }

  function closeFit() {
    if (!fit) return;
    fit.hidden = true;
    unlockPage();
    if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
  }

  function numberValue(selector) {
    const input = fit.querySelector(selector);
    const value = input ? Number(input.value) : NaN;
    return Number.isFinite(value) ? value : 0;
  }

  function heightCm() {
    const unit = fit.querySelector('[data-fit-group="height"][aria-pressed="true"]');
    if (unit && unit.dataset.fitUnit === "in") {
      const feet = numberValue("[data-fit-ft]");
      const inches = numberValue("[data-fit-inch]");
      if (!feet && !inches) return 0;
      return (feet * 12 + inches) * 2.54;
    }
    return numberValue("[data-fit-cm]");
  }

  function weightKg() {
    const unit = fit.querySelector('[data-fit-group="weight"][aria-pressed="true"]');
    const pounds = numberValue("[data-fit-lbs]");
    if (unit && unit.dataset.fitUnit === "lbs") return pounds ? pounds / 2.20462 : 0;
    return numberValue("[data-fit-kg]");
  }

  function recommend(height, weight) {
    const bands = [
      ["2XS", 155, 45],
      ["XS", 160, 50],
      ["S", 165, 57],
      ["M", 170, 64],
      ["L", 175, 72],
      ["XL", 220, 160],
    ];
    for (const [size, maxHeight, maxWeight] of bands) {
      if (height <= maxHeight && weight <= maxWeight) return size;
    }
    return "XL";
  }

  function refreshContinue() {
    const button = fit.querySelector("[data-fit-continue]");
    if (!button) return;
    button.disabled = !(heightCm() > 0 && weightKg() > 0);
  }

  contents.forEach((root) => {
    root.querySelectorAll("[data-unit]").forEach((button) => {
      button.addEventListener("click", () => setUnits(button.dataset.unit, root));
    });
  });

  if (fit) {
    fit.querySelectorAll("[data-fit-unit]").forEach((button) => {
      button.addEventListener("click", () => {
        const group = button.dataset.fitGroup;
        fit.querySelectorAll(`[data-fit-group="${group}"]`).forEach((item) => {
          item.setAttribute("aria-pressed", item === button ? "true" : "false");
        });
        fit.querySelectorAll(`[data-fit-${group}]`).forEach((panel) => {
          panel.hidden = panel.getAttribute(`data-fit-${group}`) !== button.dataset.fitUnit;
        });
        refreshContinue();
      });
    });

    fit.querySelectorAll("input").forEach((input) => {
      input.addEventListener("input", refreshContinue);
    });

    const continueButton = fit.querySelector("[data-fit-continue]");
    if (continueButton) {
      continueButton.addEventListener("click", () => {
        const size = recommend(heightCm(), weightKg());
        fit.querySelector("[data-fit-size]").textContent = size;
        fit.querySelector("[data-fit-detail]").textContent = chart[size] || "";
        fit.querySelector("[data-fit-form]").hidden = true;
        fit.querySelector("[data-fit-result]").hidden = false;
      });
    }

    const backButton = fit.querySelector("[data-fit-back]");
    if (backButton) {
      backButton.addEventListener("click", () => {
        fit.querySelector("[data-fit-result]").hidden = true;
        fit.querySelector("[data-fit-form]").hidden = false;
      });
    }
  }

  document.addEventListener("click", (event) => {
    const guideTrigger = event.target.closest(".yt-open-size-guide");
    if (guideTrigger) {
      event.preventDefault();
      event.stopPropagation();
      openGuide(guideTrigger);
      return;
    }

    const fitTrigger = event.target.closest(".yt-open-fit");
    if (fitTrigger) {
      event.preventDefault();
      event.stopPropagation();
      openFit(fitTrigger);
      return;
    }

    if (event.target.closest("[data-size-guide-close]")) {
      event.preventDefault();
      closeGuide();
    }

    if (event.target.closest("[data-fit-close]")) {
      event.preventDefault();
      closeFit();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    if (fit && !fit.hidden) closeFit();
    else if (guide && !guide.hidden) closeGuide();
  });
})();
